import { useEffect, useRef } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useProjectStore } from "@/zapi-frontend/stores/project";
import { MODEL_LEDGER_QUERY_KEY } from "../ModelLedgerIsland/useModelLedger";
import { RQA_SIM_QUERY_KEY } from "../RqaSimIsland/useRqaSim";
import { RISKS_QUERY_KEY } from "../RisksIsland/useRisks";

export function useRefreshAfterUpdates(projectId: string, isSetupActive: boolean, isLeoUpdateRunning: boolean) {
  const queryClient = useQueryClient();
  const isUpdating = isSetupActive || isLeoUpdateRunning;
  const was = useRef({ isUpdating, isLeoUpdateRunning });
  useEffect(() => {
    if (was.current.isUpdating && !isUpdating) {
      queryClient.invalidateQueries({ queryKey: [MODEL_LEDGER_QUERY_KEY, projectId] });
      queryClient.invalidateQueries({ queryKey: [RQA_SIM_QUERY_KEY, projectId] });
      queryClient.invalidateQueries({ queryKey: [RISKS_QUERY_KEY, projectId] });
      if (was.current.isLeoUpdateRunning) void useProjectStore.getState().refreshOverview(projectId);
    }
    was.current = { isUpdating, isLeoUpdateRunning };
  }, [isUpdating, isLeoUpdateRunning, projectId, queryClient]);
}
